
import { memo } from "react";
import { PropertyCard } from "./PropertyCard";
import type { Property } from "@/types/property";

interface PropertyListProps {
  properties: Property[];
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  showActions?: boolean;
}

export const PropertyList = memo(({ 
  properties, 
  onEdit, 
  onDelete,
  showActions = false 
}: PropertyListProps) => {
  return (
    <div className="container mx-auto px-4 sm:px-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {properties.map((property) => (
          <PropertyCard
            key={property.id}
            property={property}
            onEdit={showActions ? onEdit : undefined}
            onDelete={showActions ? onDelete : undefined}
          />
        ))}
      </div>
    </div>
  );
});

PropertyList.displayName = 'PropertyList';
